export default {
  root: {
    fontSize: '0.875rem'
  }
};
